var _path, _path2, _g, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwoLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -62,
    y: 244,
    width: 578,
    height: 421
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M515.957 622.638L489.572 664.022L-61.6786 285.385L-35.2932 244L515.957 622.638Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -706,
    y: -175,
    width: 1866,
    height: 1258
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.03 1082.02L1159.36 968.582L-632.756 -174.002L-705.082 -60.5597L1087.03 1082.02Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.367 676.288L546.486 613.362L-52.0879 231.734L-92.2073 294.66L506.367 676.288Z",
    fill: "#FFBF00"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -34,
    y: 154,
    width: 578,
    height: 421
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M543.957 532.638L517.572 574.022L-33.6786 195.385L-7.29321 154L543.957 532.638Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -678,
    y: -265,
    width: 1866,
    height: 1258
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.03 992.024L1187.36 878.582L-604.756 -264.002L-677.082 -150.56L1115.03 992.024Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.367 586.288L574.486 523.362L-24.0879 141.734L-64.2073 204.66L534.367 586.288Z",
    fill: "#FFBF00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoLines);
export default __webpack_public_path__ + "static/media/TwoLines.50302237024a84321faf731e7a9a3a07.svg";
export { ForwardRef as ReactComponent };